import { JSX, StrictMode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ConfigurationService } from '../../../services/configuration.service';
import Administrator from '.';
import Organization from './components/Organization';
import LoggedOff from './components/LoggedOff';
import AccessDenied from './components/AccessDenied';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Administrator />,
    },
    {
      path: '/organisation/:organizationId',
      element: <Organization />,
    },
    {
      path: '/atkomst-saknas',
      element: <AccessDenied />,
    },
    {
      path: '/session-utgangen',
      element: (
        <LoggedOff
          headingText="Du har blivit utloggad"
          bodyText="För att skydda dina uppgifter loggas du automatiskt ut efter en tids inaktivitet. Logga in igen för att fortsätta använda tjänsten."
        />
      ),
    },
  ],
  { basename: ConfigurationService.get('stralkastarenadministratorpage.basename') }
);

export default function createRouterProvider(): JSX.Element {
  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
